import React from 'react'
import { useQuery, useMutation } from '@tanstack/react-query'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import { postCreateFollowMeProfile } from '@core/Areas/FollowMe/helpers/api'
import { followMePrincipleProfileQuery } from '@core/Areas/FollowMe/helpers/queries'

export const useAutoFollowMeAccountCreation = () => {
  const { data: profileData, isLoading: isLoadingProfile } = useQuery(followMePrincipleProfileQuery)

  const { mutate: createFollowMeProfile, isPending: isCreatingProfile } = useMutation({
    mutationFn: postCreateFollowMeProfile,
    onSuccess: () => queryClient.invalidateQueries(followMePrincipleProfileQuery),
  })

  React.useEffect(() => {
    if (!isLoadingProfile && profileData === null) {
      createFollowMeProfile()
    }
  }, [isLoadingProfile, profileData, createFollowMeProfile])

  const isLoading = isLoadingProfile || isCreatingProfile

  return { isLoading }
}
